import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useFormContext } from "react-hook-form";
import { PropallyLpApiFactory } from "src/api/apiFactory";
import { formSchema, FormValues } from "src/hooks/form";
import { useApiErrorHandler } from "src/hooks/api-error";

const fp = PropallyLpApiFactory();

export const useConfirmPage = () => {
  const { submitAssessment, sending, error, clearError } = useAiAssessmentSubmit();
  const navigate = useNavigate();
  const location = useLocation();
  const { getValues } = useFormContext();

  // 画面初期表示時にバリデーションエラーの場合入力欄に戻る
  useEffect(() => {
    const values = getValues();

    const validation = formSchema.safeParse(values);

    if (!validation.success) {
      navigate({
        pathname: "/input_property",
        search: location.search,
      });
      return;
    }
  }, []);

  return {
    formData: getValues(),
    submitAssessment,
    sending,
    error,
    clearError,
  };
};

const useAiAssessmentSubmit = () => {
  const navigate = useNavigate();
  const { getValues } = useFormContext<FormValues>();
  const [sending, setSending] = useState<boolean>(false);
  const { error, clearError, handleError } = useApiErrorHandler();

  const submitAssessment = async () => {
    try {
      setSending(true);

      const formData = getValues();
      const { ...restFormData } = formData;

      const requestData = {
        ...restFormData,
        station_walk_minutes: Number(formData.station_walk_minutes) || 0,
        area: Number(formData.area) || 0,
        construction_year: Number(formData.construction_year) || 0,
        actual_sales_price: Number(formData.actual_sales_price) || 0,
        building_coverage_ratio: formData.building_coverage_ratio
          ? Number(formData.building_coverage_ratio)
          : undefined,
        floor_area_ratio: formData.floor_area_ratio ? Number(formData.floor_area_ratio) : undefined,
      };

      const response = await fp.lpV1AiAssessmentsPost(requestData);

      const resultPath = formData.property_type === "assessment" ? "/result/investment" : "/result/residence";
      navigate({ pathname: resultPath, search: location.search }, { state: { result: response.data } });
    } catch (error) {
      handleError(error);
    } finally {
      setSending(false);
    }
  };

  return {
    sending,
    submitAssessment,
    error,
    clearError,
  };
};
